import { useQuery } from '@tanstack/react-query'

import { type TypeaheadOptionType, type TypeaheadStaticModeType } from '@/defs/input'
import { fetchTypeahead } from '@/utils/typeaheadUtil'

type Props = {
  mode: TypeaheadStaticModeType
}

const EMPTY: TypeaheadOptionType[] = []

export const useTypeaheadStatic = ({ mode }: Props) => {
  const {
    data: options = EMPTY,
    error,
    isLoading: loading,
  } = useQuery({
    queryFn: () => fetchTypeahead(mode),
    queryKey: ['typeahead', mode],
    retryOnMount: true,
  })

  if (error) throw new Error('Error fetching the options for typeahead.')

  return { loading, options }
}
